import { FC } from "react";
import { Box, Button } from '@mui/material';
import { Notificacao } from './DialogNotification';
import { resolveProtocolUrl } from "src/store/global.store";

const ContentNotification: FC<Notificacao & {className?: string}> = ({ elementoAtributos, handleCloseDialog, onClose, className}) => {
  
  const handleSaibaMais = () => {
    if (elementoAtributos.linkSaibaMais && elementoAtributos.linkSaibaMais.trim().length > 0 ) {
      window.open(elementoAtributos.linkSaibaMais)
    }
  };

  const contemTitulo = (elementoAtributos.titulo.trim() !== '' || elementoAtributos.titulo.trim() !== '');
  const contemLinkSaibaMais = elementoAtributos.linkSaibaMais && elementoAtributos.linkSaibaMais.trim().length > 0;

  return (
      // <div dividers={scroll === 'paper'}>
      <Box className='div-conteudo'>
          {/* <Box className='div-fechar'><IconButton className="botao-fechar" onClick={handleClose}><Close /></IconButton></Box>  */}
          { elementoAtributos.image && (  
            <img src={resolveProtocolUrl(elementoAtributos.image)} className={contemTitulo ? 'image-conf' : 'image-conf padding-bottom-image'}/>
          )}
          {(elementoAtributos.titulo.trim() !== '' || elementoAtributos.titulo.trim() !== '') && (
              <Box className={contemLinkSaibaMais ? 'content-titulo-descricao' : 'content-titulo-descricao padding-bottom-notification'} >
                  { elementoAtributos.titulo.trim() !== '' && (
                      <Box className='content-titulo'>
                          {elementoAtributos.titulo}
                      </Box>
                  )} 
                  { elementoAtributos.descricao.trim() !== '' && (
                      <Box className='content-descricao' dangerouslySetInnerHTML={{ __html: elementoAtributos.descricao }} />
                  )}
              </Box>
          )}
          { elementoAtributos.linkSaibaMais && elementoAtributos.linkSaibaMais.trim().length > 0 && (
              <Box className="div_saiba_mais padding-bottom-notification" >
                  <Button className='btn-saiba-mais'
                      onClick={handleSaibaMais}
                      color="secondary">
                      SAIBA MAIS
                  </Button>
              </Box>
          )}
      </Box>
  );
}

export default ContentNotification;
